import init from "@/javascripts/shared/utils/init"

init(() => {
  const swedishContentModalTriggerEl = document.querySelector(
    `#js-swedish-page-warning-modal-trigger`
  )

  const continueToSwedishPageEl = document.querySelector(
    `.js--continue-to-swedish-page`
  )

  const triggerLinks = document.querySelectorAll(
    `.js--swedish-page-warning-link`
  )

  if (!swedishContentModalTriggerEl || !continueToSwedishPageEl) return

  triggerLinks.forEach((link) => {
    link.addEventListener(`click`, (e) => {
      e.preventDefault()
      window.vb_temp_link = link.href
      swedishContentModalTriggerEl.click()
    })
  })

  continueToSwedishPageEl.addEventListener(`click`, () => {
    if (!window.vb_temp_link) return
    window.location.href = window.vb_temp_link
  })
})
